import React, {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  Space,
  message,
  DatePicker,
  Tabs,
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import "./index.scss";
import { FileDetail, CustomUploadNew1 } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const VendorMWorkerModal = forwardRef(({ submitInitFn }, ref) => {
  const [form] = Form.useForm();
  const [type, setType] = useState("New");
  const [oldState, setOldState] = useState({});
  const [modalFlag, setModalFlag] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [detail, setDetail] = useState(null);
  const customUploadNewRef = useRef([]);
  const [groupIdList, setGroupIdList] = useState([]);
  const [supervisorList, setSupervisorList] = useState([]);
  const [propIdList, setPropIdList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [tabsKey, setTabsKey] = useState("w9");
  const [uploadFile, setUploadedFile] = useState([]);

  useImperativeHandle(ref, () => ({
    openModal: ({ type, oldState = {} }) => {
      setType(type);
      setOldState(oldState);
      setModalFlag(true);
    },
  }));

  const afterOpenChangeFn = (flag) => {
    if (flag) {
      if (type !== "New") {
        groupIdListFn();
        supervisorListFn();
        stateListFn();
        getDetailFn();
        getFileListFn();
      } else {
        groupIdListFn();
        supervisorListFn();
        propIdListFn();
        stateListFn();
      }
    } else {
      setTabsKey("w9");
      setDetail(null);
      form.resetFields();
      setBtnLoading(false);
      setBtnDisabled(false);
      setUploadedFile([]);
      setFilePaths([]);
      setGroupIdList([]);
      setSupervisorList([])
      setPropIdList([]);
      setStateList([]);
    }
  };

  const getDetailFn = async () => {
    setBtnDisabled(true);
    const response = await http.get(api.vendorMonthlyShowById, {
      params: { vendorId: oldState?.vendorId },
    });
    if (response.code === "1") {
      const { propInfoList, udate, sysDate } = response.data;
      if(propInfoList?.length){
        setPropIdList(propInfoList);
      } else {
        propIdListFn();
      }
      setDetail({
        ...detail,
        ...response.data,
      });
      form.setFieldsValue({
        ...response.data,
        udate: udate && dayjs(udate),
        sysDate: sysDate && dayjs(sysDate),
      });
    }
    setBtnDisabled(false);
  };

  const base64ToUrlFn = (base64Data) => {
    const base64HeaderMatch = base64Data.match(/^data:(.*?);base64,/);
    let cleanBase64 = base64Data;
    if (base64HeaderMatch) {
      cleanBase64 = base64Data.replace(base64HeaderMatch[0], "");
    }
    // 将 Base64 转换为二进制数据
    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const url = window.URL.createObjectURL(
      new Blob([byteArray], {
        type: base64HeaderMatch?.[1] || "application/pdf",
      }),
    );
    return url;
  };

  const getFileListFn = async () => {
    const typeList = ["w9", "contracts", "insurance_certificate"];
    const response = await http.get(api.vendorMonthlyFile, {
      params: { id: oldState?.vendorId, typeList: String(typeList) },
    });
    if (response.code === "1") {
      if (["Edit"].includes(type)) {
        const list = await Promise.all(
          (response.data || [])?.map(async (item) => ({
            ...item,
            allPath: await base64ToUrlFn(item.base64),
            name: item.name || item.fileName,
            id: item.fileUploadId,
          })),
        );
        setUploadedFile(list);
        typeList.map((item) =>
          customUploadNewRef.current?.[item].initUpdateList(
            list.filter((v) => v.customType === item),
          ),
        );
        setFilePaths(list);
      }
    }
  };

  const testFn = async () => {
    // const formData = form.getFieldsValue();
    // console.log("====formData", formData);
    console.log("====filePaths", filePaths);
    console.log("====uploadFile", uploadFile);
  };

  const submitAddOrEditFn = async () => {
    const flag = type === "New";
    const formValues = form.getFieldValue();
    const hirDate = formValues?.hirDate?.format?.("YYYY-MM-DD") || undefined;
    setBtnLoading(true);
    const response = await http.post(
      flag ? api.vendorMonthlyAdd : api.vendorMonthlyUpdate,
      {
        ...formValues,
       hirDate,
        uuidList: filePaths.map((item) => item.uuid),
      },
    );
    if (response.code === "1") {
      message.success(`${flag ? "New" : "Edit"} successfully`);
      setModalFlag(false);
      submitInitFn();
    } else {
      commonFn.modalFailedFn(response);
    }
    setBtnLoading(false);
  };

  const submitFn = async () => {
    form
      .validateFields()
      .then((value) => {
        submitAddOrEditFn();
      })
      .catch((err) => {
        console.log(err, "===err");
      });
  };

  const deleteOldFn = async (file) => {
    let flag = false;
    const response = await http.get(api.commonDelFiles, {
      params: { id: file.id },
    });
    if (response.code === "1") {
      flag = true;
    }
    return flag;
  };

  const deleteBase64FileFn = async (file) => {
    const list = filePaths.filter((item) =>
      file?.uuid ? item.uuid !== file.uuid : item.uid !== file.uid,
    );
    return list;
  };

  const groupIdListFn = async (content = "") => {
    const response = await http.get(api.commonGroupList, {
      params: { content },
    });
    if (response.code === "1") {
      setGroupIdList(response.data || []);
    }
  };

  const supervisorListFn = async (content = "") => {
    const response = await http.get(api.getSupervisorNameDict, {
      params: { content },
    });
    if (response.code === "1") {
      setSupervisorList(response.data || []);
    }
  };

  const propIdListFn = async (content = "") => {
    const response = await http.get(api.propSearch, { params: { content } });
    if (response.code === "1") {
      setPropIdList(response.data || []);
    }
  };

  const stateListFn = async () => {
    const response = await http.get(api.vendorVendorType, {
      params: { flag: "state" },
    });
    setStateList(response || []);
  };

  const addOldFn = async (file, type) => {
    setBtnDisabled(true);
    const list = file.filter((item) => !item.uuid && !item.id);
    const uploadedFiles = await commonFn.uploadFiles(list, {
      type,
      foreignId: "q1FJeKGXg6l9DKvolVahqXl2477uRIwqcj9lNfRK",
    });
    const temp = uploadedFiles.reduce((arr, u) => {
      const f = (list || []).find((v) => v.uid === u.customId);
      if (f) {
        const { originFileObj, allPath, size, type } = f;
        arr.push({
          ...u,
          originFileObj,
          allPath:
            allPath || (originFileObj && URL.createObjectURL(originFileObj)),
          size,
          type,
        });
      }
      return arr;
    }, []);
    return {
      flag: true,
      fileData: temp[0],
    };
  };

  const uploadTabsChildrenDoc = (name) => {
    return (
      <Form.Item
        labelCol={{ span: 0 }}
        wrapperCol={{ span: 24 }}
        name={name}
        label={null}
      >
        <>
          <div style={{ height: "50px" }}></div>
          <CustomUploadNew1
            ref={(el) => (customUploadNewRef.current[name] = el)}
            customConfig={{
              uploadButtonStyle: {
                top: "0",
              },
              pdfHeight: "62vh",
              fileFullName: "name",
              notMultiple: true,
              accept: ".jpg, .jpeg, .png, .pdf",
              status: "add",
              deleteOldFn: deleteOldFn,
              deleteBase64FileFn: deleteBase64FileFn,
              addOldFn: (file) => addOldFn(file, tabsKey),
            }}
            setFilePaths={setFilePaths}
            filePaths={filePaths.filter((item) => item.customType === name)}
            setBtnDisabled={setBtnDisabled}
            btnDisabled={btnDisabled}
          />
        </>
      </Form.Item>
    );
  };

  const uploadTabsDoc = () => {
    const items = [
      {
        key: "w9",
        label: "Upload W-9 Documents",
        forceRender: true,
        children: uploadTabsChildrenDoc("w9"),
      },
      {
        key: "insurance_certificate",
        label: "Upload Insurance Certificate",
        forceRender: true,
        children: uploadTabsChildrenDoc("insurance_certificate"),
      },
      {
        key: "contracts",
        label: "Upload Contracts",
        forceRender: true,
        children: uploadTabsChildrenDoc("contracts"),
      },
    ];
    return (
      <Tabs
        activeKey={tabsKey}
        items={items}
        onChange={(key) => setTabsKey(key)}
      />
    );
  };

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {`${type} Vendor M.Worker`}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      className="VendorMWorkerModal"
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="80%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        labelWrap={true}
        labelAlign="right"
        initialValues={{
          vendorType: "Maintenance",
          flg1099: "N",
        }}
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Service Provides
            </div>

            <Form.Item
              name="vendid"
              label="Vendor Code"
              rules={[{ required: true }]}
            >
              <Input disabled={type !== "New"} />
            </Form.Item>

            <Form.Item
              name="name"
              label="Vendor (Company) Name"
              rules={[{ required: true }]}
            >
              <Input disabled={type !== "New"} />
            </Form.Item>

            <Form.Item
              name="vendorType"
              label="Vendor Type"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Please Select Vendor Type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[{ value: "Maintenance", label: "Maintenance" }]}
              />
            </Form.Item>
            {commonFn.formInputNumberDoc({
              form,
              name: "monthlySalary",
              label: "Contract Amount",
              allowNegative: true,
              isNoRequired: true,
              disabled:true
            })}

            <Form.Item name="hirDate" label="Contracted Date" >
              <DatePicker
                format="YYYY-MM-DD"
                style={{ width: "100%" }}
                allowClear
                disabled
              />
            </Form.Item>

            <Form.Item name="remarks" label="Remark">
              <Input placeholder="Please input Remark" />
            </Form.Item>

            <Form.Item name="fedId" label="Tax ID / SSN">
              <Input placeholder="Please input Tax ID / SSN" />
            </Form.Item>

            <Form.Item
              name="flg1099"
              label="If 1099"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Please Select If 1099"
                options={[
                  { value: "Y", label: "Yes" },
                  { value: "N", label: "No" },
                ]}
                allowClear
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>

            <Form.Item
              name="status"
              label="Status"
              rules={[{ required: true }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Status"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
              />
            </Form.Item>

            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Contact Info
            </div>

            <Form.Item name="nameKey" label="Name">
              <Input placeholder="Please input Name" />
            </Form.Item>

            <Form.Item name="phoneWork" label="Work Phone">
              <Input placeholder="Please input Work Phone" />
            </Form.Item>

            <Form.Item name="ext" label="Extension">
              <Input placeholder="Please input Extension" />
            </Form.Item>

            <Form.Item name="phone" label="Mobile">
              <Input placeholder="Please input Mobile" />
            </Form.Item>

            <Form.Item name="email" label="Email">
              <Input placeholder="Please input Email" />
            </Form.Item>

            <Form.Item name="web" label="Website">
              <Input placeholder="Please input Website" />
            </Form.Item>

            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Access
            </div>

            <Form.Item name="supervisorId" label="Supervisor">
              <Select
                placeholder="Please Select Supervisor"
                // mode="multiple"
                showSearch
                allowClear
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.fullEmailName ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  value: "accountId",
                  label: "fullEmailName",
                }}
                options={supervisorList}
              />
            </Form.Item>

            <Form.Item name="groupIdList" label="Group">
              <Select
                placeholder="Please Select Group"
                mode="multiple"
                showSearch
                allowClear
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.geographyGroup ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  value: "groupId",
                  label: "geographyGroup",
                }}
                options={groupIdList}
              />
            </Form.Item>

            <Form.Item
              name="propIdList"
              label="Property"
              // rules={[{ required: true }]}
            >
              <Select
                placeholder="Please Select Property"
                mode="multiple"
                showSearch
                allowClear
                onSearch={propIdListFn}
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.propName ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  value: "propId",
                  label: "propName",
                }}
                options={propIdList}
              />
            </Form.Item>

            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Mailing Address (This will print on Check)
            </div>

            <Form.Item name="street" label="Address or P.O.Box">
              <Input placeholder="Please input Address or P.O.Box" />
            </Form.Item>

            <Form.Item name="city" label="City">
              <Input placeholder="Please input City" />
            </Form.Item>

            <Form.Item name="state" label="State">
              <Select
                placeholder="Please Select State"
                showSearch
                allowClear
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.stateName ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  value: "stateM",
                  label: "stateName",
                }}
                options={stateList}
              />
            </Form.Item>

            <Form.Item name="zip" label="Zip">
              <Input placeholder="Please input Zip" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Physical Address
            </div>

            <Form.Item name="streetM" label="Address">
              <Input placeholder="Please input Address" />
            </Form.Item>

            <Form.Item name="cityM" label="City">
              <Input placeholder="Please input City" />
            </Form.Item>

            <Form.Item name="stateM" label="State">
              <Select
                placeholder="Please Select State"
                showSearch
                allowClear
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.stateName ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  value: "stateM",
                  label: "stateName",
                }}
                options={stateList}
              />
            </Form.Item>

            <Form.Item name="zipM" label="Zip">
              <Input placeholder="Please input Zip" />
            </Form.Item>

            {/* {["Edit"].includes(type) ? (
              <>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  <HomeOutlined style={{ marginRight: "8px" }} />
                  APP Info
                </div>

                <Form.Item
                  name="appActive"
                  label="APP Active"
                  // rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Please Select APP Active"
                    showSearch
                    allowClear
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      { value: "0", label: "No" },
                      { value: "1", label: "Yes" },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  name="appEmail"
                  label="APP Registered Email (User Name)"
                >
                  <Input placeholder="Please input APP Registered Email (User Name)" />
                </Form.Item>

                <Form.Item name="password" label="Reset Password">
                  <Input.Password placeholder="Please input Reset Password" />
                </Form.Item>

                <Form.Item name="confirmPassword" label="Confirm Password">
                  <Input.Password placeholder="Please input Confirm Password" />
                </Form.Item>

                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  <HomeOutlined style={{ marginRight: "8px" }} />
                  Create And Edit Info
                </div>

                <Form.Item name="udate" label="Last Updated Date & Time">
                  <DatePicker
                    disabled
                    style={{ width: "100%" }}
                    format="MM/DD/YYYY"
                  />
                </Form.Item>

                <Form.Item name="usid" label="Last Updated By">
                  <Input disabled />
                </Form.Item>

                <Form.Item name="sysDate" label="Created Date & Time">
                  <DatePicker
                    disabled
                    style={{ width: "100%" }}
                    format="MM/DD/YYYY"
                  />
                </Form.Item>

                <Form.Item name="usid" label="Created By">
                  <Input disabled />
                </Form.Item>
              </>
            ) : null} */}
          </Col>
          <Col span={12}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Upload PDF image
            </div>

            <div className="uploadText">
              Uploaded files only support JPG, PNG or PDF.
            </div>
            {uploadTabsDoc()}
          </Col>
        </Row>
      </Form>
      <div style={{ textAlign: "center" }}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
              TEST
            </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          {(type !== "view" && (
            <Button
              type="primary"
              onClick={submitFn}
              loading={btnLoading}
              disabled={btnDisabled}
            >
              Submit
            </Button>
          )) ||
            null}
        </Space>
      </div>
    </Modal>
  );
});

export default VendorMWorkerModal;
